export default __webpack_public_path__ + "static/buzie_3-b2e9d0e1d75cfaa8062668e99b562533.png";